export default __webpack_public_path__ + "static/media/ordSugess.175dc1b1.svg";